import Container from "../components/Container/Container";
import {Button, Form, Space, Table, Tag} from "antd";
import {convertToInt, formatDateTime, numberFormat} from "../helpers/helpers";
import {useEffect, useState} from "react";
import getTransactions from "../api/transaction/getTransactions";
import useAuthHeader from "../hooks/useAuthHeader";
import Search from "../components/Search/Search";
import dayjs from "dayjs";
import {ExportOutlined} from "@ant-design/icons";
import ExportFile from "../components/ExportFile/ExportFile";

function Transaction() {
    const [dataSource,setDataSource] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const accessToken = useAuthHeader();
    const [form] = Form.useForm();
    const [openExport, setOpenExport] = useState(false);
    const [summaryData, setSummaryData] = useState({
        totalAmount: 0
    });
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });

    const items = [
        {
            name: 'createdAt',
            type: 'date',
            placeholder: 'Thời gian'
        }
    ];

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: true,
            align: 'center'
        },
        {
            title: 'Cộng/Trừ',
            dataIndex: 'io',
            align: 'center',
            filters: [
                {
                    text: 'Cộng tiền',
                    value: 1
                },
                {
                    text: 'Trừ tiền',
                    value: -1
                }
            ],
            render: (value) => {
                if (value === 1) {
                    return <Tag color={'green'}>Cộng tiền</Tag>
                }
                return <Tag color={'red'}>Trừ tiền</Tag>
            }
        },
        {
            title: 'Số tiền',
            dataIndex: 'amount',
            sorter: true,
            align: 'center',
            render: (value) => {
                return numberFormat(value);
            }
        },
        {
            title: 'Số dư',
            dataIndex: 'balance',
            sorter: true,
            align: 'center',
            render: (value) => {
                return numberFormat(value);
            }
        },
        {
            title: 'Nội dung',
            dataIndex: 'description'
        },
        {
            title: 'Thời gian',
            dataIndex: 'createdAt',
            sorter: true,
            align: 'center',
            render: (value) => {
                return formatDateTime(value);
            }
        }
    ]
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };

    const handleSearch =  () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        })
    }
    const fetchData = async () => {
        setTableLoading(true);
        const response = await getTransactions(accessToken,tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
            setSummaryData({
                totalAmount: response.data.totalAmount
            })
        }
        setTableLoading(false);
    }
    useEffect(() => {
        fetchData();
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        JSON.stringify(tableParams.sorter),
        JSON.stringify(tableParams.search),
        JSON.stringify(tableParams.filters),
    ]);
    return (
        <Container>
            <Space
                style={{
                    marginBottom: '20px'
                }}
            >
                <Button type={'primary'} icon={<ExportOutlined/>} onClick={() => setOpenExport(true)} title={'Xuất file'}>Xuất file</Button>
            </Space>
            <Search
                form={form}
                items={items}
                onSearch={handleSearch}
            />
            <Table
                rowKey={'uuid'}
                columns={columns}
                dataSource={dataSource}
                bordered={true}
                scroll={{
                    x: 1200
                }}
                loading={tableLoading}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                summary={(data) => {

                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={2}>
                                Thống kê
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align={'center'}>
                                <Tag color={'blue'}>{numberFormat(summaryData.totalAmount)}</Tag>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }}
            />
            <ExportFile
                open={openExport}
                setOpen={setOpenExport}
                path={'/transaction/exportFile'}
            />
        </Container>
    )
}

export default Transaction;
